module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_add-to-unscopables.js
// module id = 56
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_add-to-unscopables.js